import React from 'react';
import PropTypes from 'prop-types';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.handleMail = this.handleMail.bind(this);
  }

  handleMail(event) {
    event.preventDefault();
    const email = 'mailto:ci_marketing@chubb.com?subject=CI%20App%20Feedback';
    window.location = email;
  }

  render() {
    return (
      <footer className="footer" role="contentinfo">
        <div className="footer__banner-wrap wrapper">
          <a
            href="https://www.chubb.com/us-en/business-insurance/commercial-landing-page.aspx#sectionIndustryCamp"
            className="footer__banner"
            target="_blank"
            data-cta="Rediscover Services Banner"
            rel="noopener noreferrer"
          >
            Check out our industry campaigns&nbsp;&nbsp;&nbsp;
            <i className="fa fa-angle-right " />
          </a>
        </div>
        <div className="footer__wrapper wrapper">
          <div className="container">
            <img src="/img/footer-logo.svg" className="footer__logo" alt="Chubb Logo" />
          </div>
          <section className="footer__content">
            <p className="footer__copy">
              Chubb is the marketing name used to refer to subsidiaries of Chubb Limited providing
              insurance and related services. For a list of these subsidiaries, please visit our
              website at{' '}
              <a
                rel="noopener noreferrer"
                className="footer__link"
                target="_blank"
                href="https://www.chubb.com"
              >
                www.chubb.com
              </a>
              . Insurance provided by ACE American Insurance Company and its U.S.-based Chubb
              underwriting company affiliates.{' '}
            </p>
            <p className="footer__copy">
              All products may not be available in all states.
              <br />
              This communication contains product summaries only. Coverage is subject to the
              language of the policies as actually issued. Surplus lines insurance sold only through
              licensed surplus lines producers.
            </p>
          </section>
          <button
            type="button"
            className="footer__feedback"
            onClick={this.handleMail}
            data-cta="Email: Further Information"
          >
            {this.props.feedback}
          </button>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js